import {
  getRecommendChatErrorCode,
  getRecommendChatErrorMessage,
} from '@app/api/RecommendChat/errors';
import { handleCatchError } from '@app/services';

// Бэк проксирует сырой ответ SMS-микросервиса как есть, поэтому при просрочке
// или отзыве его credentials оператор видит "SMS microservice unauthorized
// (401). Response: {"detail":"Invalid credential"}" — техническую деталь
// интеграции, а не ошибку клиента. Подменяем такой текст на понятную
// заглушку, пока бэк не начнёт присылать человекочитаемое сообщение сам.
// Остальные ошибки возвращаем как есть: showNotification сам распознаёт
// служебные случаи (режим обслуживания, AbortError) по форме объекта, и
// прогонять их через handleCatchError заранее нельзя — это его сломает.
const SMS_UNAUTHORIZED_ERROR_PATTERN = /SMS microservice unauthorized/i;

const SMS_UNAUTHORIZED_ERROR_TEXT =
  'Не удалось отправить SMS: интеграция с SMS-сервисом потеряла доступ. Обратитесь в техподдержку.';

export const getSendMessageToClientError = (error: unknown): unknown => {
  if (getRecommendChatErrorCode(error))
    return getRecommendChatErrorMessage(error);
  if (SMS_UNAUTHORIZED_ERROR_PATTERN.test(handleCatchError(error))) {
    return SMS_UNAUTHORIZED_ERROR_TEXT;
  }

  return error;
};
